import { Component, EventEmitter, Input, Output } from '@angular/core';

const ALERT_TYPE_DEFAULT = 'warning';


export class SkyAlertComponent {
  
  public set alertType(value: string) {
    this._alertType = value;
  }

  public get alertType() {
    return this._alertType || ALERT_TYPE_DEFAULT;
  }

  
  public closeable: boolean;

  
  public closed: boolean;

  
  public closedChange = new EventEmitter<boolean>();

  private _alertType: string;

  public close() {
    this.closed = true;
    this.closedChange.emit(true);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-alert',
  styles: [`.sky-alert {
  padding: 0 10px;
  margin-bottom: 20px;
  border-left: solid 30px;
  color: #282b31;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.sky-alert .sky-alert-content {
  padding-top: 10px;
  padding-bottom: 10px;
  width: 100%;
}

.sky-alert .sky-alert-content ::ng-deep a {
  color: rgba(40, 43, 49, 0.8);
  text-decoration: underline;
}

.sky-alert .sky-alert-content ::ng-deep a:hover {
  color: #282b31;
}

.sky-alert button {
  margin-left: auto;
  width: 32px;
  height: 32px;
}

.sky-alert-info {
  background-color: #81d4f7;
  border-color: #00b4f1;
}

.sky-alert-info:before {
  content: "\\f06a";
  font-family: FontAwesome;
  margin-left: -31px;
  margin-right: 20px;
  color: #ffffff;
}

.sky-alert-success {
  background-color: #b7da9b;
  border-color: #71bf43;
}

.sky-alert-success:before {
  content: "\\f00c";
  font-family: FontAwesome;
  margin-left: -32px;
  margin-right: 19px;
  color: #ffffff;
}

.sky-alert-warning {
  background-color: purple;
  border-color: #fbb034;
}

.sky-alert-warning:before {
  content: "\\f071";
  font-family: FontAwesome;
  margin-left: -32px;
  margin-right: 19px;
  color: #ffffff;
}

.sky-alert-danger {
  background-color: #f7a08f;
  border-color: #ef4044;
}

.sky-alert-danger:before {
  content: "\\f071";
  font-family: FontAwesome;
  margin-left: -32px;
  margin-right: 19px;
  color: #ffffff;
}

.sky-alert-close {
  cursor: pointer;
  font-weight: bold;
  line-height: 1;
  margin: 0;
  padding: 0;
  color: #282b31;
  opacity: 0.8;
  border: none;
  background-color: transparent;
  display: none;
}

.sky-alert-close:hover {
  opacity: 1.0;
}

.sky-alert-closeable .sky-alert-close {
  display: block;
}
`],
  template: `<div
    class="sky-alert sky-rounded-corners"
    [ngClass]="{
      'sky-alert-info': alertType === 'info',
      'sky-alert-success': alertType === 'success',
      'sky-alert-warning': alertType === 'warning',
      'sky-alert-danger': alertType === 'danger',
      'sky-alert-closeable': closeable
    }"
    [hidden]="closed"
    role="alert"
>
  <div class="sky-alert-content"><ng-content></ng-content></div>
  <button
      type="button"
      class="sky-alert-close"
      (click)="close()"
      [attr.aria-label]="'alert_close' | skyResources"
      [hidden]="!closeable"
  >
    <span aria-hidden="true"><i class="fa fa-close"></i></span>
  </button>
</div>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'alertType': [{ type: Input },],
'closeable': [{ type: Input },],
'closed': [{ type: Input },],
'closedChange': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
